import { atom } from "jotai";
import { Refresh } from "../types/refresh";

export const refreshAtomGroups = atom<Refresh | null>(null);
